import { combineReducers } from 'redux';
import { createReducer } from '@api/createArrayRequestStore';
import coreReducer from './reducer';
import { SCOPE } from './types';

export { default as selectors } from './selectors';
export { default as sagas } from './sagas';

export const reducer = combineReducers({
  core: coreReducer,
  requests: createReducer(SCOPE),
});

export { SCOPE };
